import '@vanilla-extract/css/vanilla.virtual.css?ve-css=QG1lZGlhIChtYXgtd2lkdGg6IDcxMXB4KSB7CiAgLm10Nng4OTAgewogICAgZGlzcGxheTogbm9uZSAhaW1wb3J0YW50OwogIH0KfQ';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=QG1lZGlhIChtaW4td2lkdGg6IDcxMnB4KSB7CiAgLm10Nng4OTEgewogICAgZGlzcGxheTogbm9uZSAhaW1wb3J0YW50OwogIH0KfQ';
export var desktopOnly = 'mt6x890';
export var mobileOnly = 'mt6x891';